module.exports = __webpack_public_path__ + "assets/img/xygl__d_1.75d854a5.png";